import React from 'react';
import { motion } from 'framer-motion';

const AboutMePage = () => {
  // Variant pro plynulé vplutí sekcí
  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
  };

  return (
    <div style={{ backgroundColor: '#f4e9dc', minHeight: '100vh', paddingTop: '140px', paddingBottom: '100px', color: '#2b1f18' }}>
      
      {/* 1. ÚVODNÍ SEKCE */}
      <section style={{ maxWidth: '1000px', margin: 'auto', padding: '0 20px', textAlign: 'center' }}>
        <motion.h1 
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          style={{ fontSize: '3.5rem', marginBottom: '50px' }}
        >
          Můj příběh
        </motion.h1>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '50px', alignItems: 'center', textAlign: 'left' }}>
          <motion.div 
            style={{ flex: '1', minWidth: '300px' }}
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <img src="images/dilna-profil.jpg" alt="V dílně" style={{ width: '100%', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }} />
          </motion.div>

          <motion.div 
            style={{ flex: '1', minWidth: '300px' }}
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p style={{ fontSize: '1.2rem', marginBottom: '20px', fontWeight: '500' }}>
              Jmenuji se Václav a práce se dřevem pro mě není jen řemeslo...
            </p>
            <p style={{ fontSize: '1.1rem', color: '#5a4935' }}>
              Je to způsob, jak vdechnout život materiálu, který tu byl dávno před námi. Každý kus má svou texturu a vůni.
            </p>
          </motion.div>
        </div>
      </section>

      {/* 2. MILNÍKY (ŠKOLY & STUDIUM) */}
      <motion.section 
        style={{ maxWidth: '800px', margin: '100px auto', padding: '0 20px' }}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
      >
        <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '40px' }}>Cesta k řemeslu</h2>
        <div style={{ borderLeft: '3px solid #d1b892', paddingLeft: '30px', position: 'relative' }}>
          <div style={{ marginBottom: '40px' }}>
            <h3 style={{ color: '#8b5a2b' }}>Studium a základy</h3>
            <p>Po absolvování školy jsem se začal naplno věnovat uměleckému řezbářství, kde jsem hledal svůj vlastní rukopis...</p>
          </div>
          {/* Tady můžeš přidat další školy/milníky */}
        </div>
      </motion.section>

      {/* 3. SYMPOZIA (GRID S POPISKY) */}
      <section style={{ backgroundColor: '#efe4d3', padding: '80px 20px' }}>
        <div style={{ maxWidth: '1100px', margin: 'auto' }}>
          <motion.h2 
            style={{ textAlign: 'center', fontSize: '2.5rem', marginBottom: '50px' }}
            variants={fadeInUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            Mezinárodní sympozia
          </motion.h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px' }}>
            {/* Příklad sympozia - můžeš jich tam dát kolik chceš */}
            {['Sympozium 1', 'Sympozium 2', 'Sympozium 3'].map((item, idx) => (
              <motion.div 
                key={idx}
                whileHover={{ y: -10 }}
                style={{ background: '#fcf6ed', padding: '25px', borderRadius: '10px', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}
              >
                <h4 style={{ color: '#8b5a2b', marginBottom: '10px' }}>{item}</h4>
                <p style={{ fontSize: '0.9rem' }}>Krátký popisek o tom, co jsi tam vytvořil a jaká tam byla atmosféra.</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. MISTR & UČITEL (HODONÍN) */}
      <section style={{ maxWidth: '1000px', margin: '100px auto', padding: '0 20px' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap-reverse', gap: '50px', alignItems: 'center' }}>
          <motion.div 
            style={{ flex: '1.2', minWidth: '300px' }}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <h2 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>Předávání zkušeností</h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
              Dnes působím jako **mistr odborného výcviku v Hodoníně**. Učím mladé truhláře, že dřevo není jen "deska", ale živý materiál.
              Práce se studenty mě naplňuje – vidět, jak se pod jejich rukama mění kus špalku v něco smysluplného, je ta největší odměna.
            </p>
          </motion.div>
          <motion.div 
            style={{ flex: '0.8', minWidth: '250px' }}
            initial={{ opacity: 0, rotate: 5 }}
            whileInView={{ opacity: 1, rotate: 0 }}
            viewport={{ once: true }}
          >
            <img src="images/skola-mistr.jpg" alt="Výuka v Hodoníně" style={{ width: '100%', borderRadius: '15px', transform: 'rotate(-2deg)' }} />
          </motion.div>
        </div>
      </section>

    </div>
  );
};

export default AboutMePage;